<div class="container">
  <mat-icon *ngFor="let icon of iconList" color="primary">{{ icon }}</mat-icon>

  <span class="margin-left">{{ rating }}</span>

  <span *ngIf="totalReview" class="margin-left"
    >({{ totalReview }}
    {{
      (totalReview > 1
        ? 'rating-star-icon.text.reviews'
        : 'rating-star-icon.text.review'
      ) | translate
    }})</span
  >
</div>
